module.exports = __webpack_public_path__ + "static/img/biankuang_m01.62f8a77.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang_m01.png
// module id = DLzs
// module chunks = 1